import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Heading, TextAccent } from '../../../components';
import { Wrapper, Section, ImageWrapper, Block } from './GroupOneFeatures.style';

/**
 * Work/Sesame: Features group one
 */
const GroupOneFeatures = () => {
  const data = useStaticQuery(graphql`
    query {
      sesameHomepage: file(relativePath: { eq: "sesame-homepage.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Section>
        <Block gridArea="data-driven-solutions">
          <Heading element="h3" size="h4" weight={700} colorKind="light">
            Data-driven features
          </Heading>
          <TextAccent colorKind="light">
            We measured features with clear metrics and A/B tests, and analyzed the results to drive optimizations that
            improved conversion.
          </TextAccent>
        </Block>
        <Block gridArea="analytics-infrastructure">
          <Heading element="h3" size="h4" weight={700} colorKind="light">
            Refactoring analytics infrastructure
          </Heading>
          <TextAccent colorKind="light" withSpacing>
            One of my first challenges at Sesame was enhancing our analytics layer, built on Mixpanel and Segment. I
            focused on ensuring accurate tracking of users across sessions, from non-authenticated to authenticated; so
            we could capture a complete view of their journey and extract actionable insights into user behavior.
          </TextAccent>
          <TextAccent colorKind="light">
            This required close collaboration with backend engineers to align tracking logic and data definitions,
            ensuring a consistent analytics stack and a unified view of the user journey.
          </TextAccent>
        </Block>
        <Block gridArea="image">
          <ImageWrapper>
            <Img
              fluid={data.sesameHomepage.childImageSharp.fluid}
              loading="eager"
              imgStyle={{ objectFit: 'contain' }}
              alt="Image of Sesame homepage"
            />
          </ImageWrapper>
        </Block>
        <Block gridArea="interviews">
          <Heading element="h3" size="h4" weight={700} colorKind="light">
            Growing the team
          </Heading>
          <TextAccent colorKind="light">
            Led interviews for senior engineering candidates, mentored engineers across career development paths, and
            provided architectural guidance. These efforts improved our technical standards and encouraged a culture of
            excellence, responsibility, and teamwork.
          </TextAccent>
        </Block>
        <Block gridArea="graphql-infrastructure">
          <Heading element="h3" size="h4" weight={700} colorKind="light">
            GraphQL and micro-service infrastructure
          </Heading>
          <TextAccent colorKind="light">
            I collaborated closely with backend engineers to design and implement efficient GraphQL resolvers, enabling
            smooth communication across 50+ microservices. This work improved data consistency, performance, and
            scalability, allowing frontend teams to build features without worrying about backend complexity.
          </TextAccent>
        </Block>
        <Block gridArea="monitoring">
          <Heading element="h3" size="h4" weight={700} colorKind="light">
            Monitoring and observability
          </Heading>
          <TextAccent colorKind="light">
            We tracked errors diligently and resolved issues before they caused bottlenecks, using user pain scores to
            prioritize fixes and improve the experience. This proved an effective way to stay accountable for our work.
          </TextAccent>
        </Block>
      </Section>
    </Wrapper>
  );
};

export default GroupOneFeatures;
